// extracted by mini-css-extract-plugin
export default {"wrapper":"ProductUpload_wrapper__qda16"};